import { useState, useEffect } from "react";

// A custom React hook that concatenates two strings and returns the result.
// Useful for combining strings within functional components.

/**
 * Custom hook to fetch table data based on dynamic column selection.
 * @param {String} initialString - intial value
 * @param {String} stringToConcat - second value that we need to concat with initial value
 */

const useConcatenatedString = (initialString: String, stringToConcat: String) => {
  const [concatenatedString, setConcatenatedString] = useState("");

  useEffect(() => {
    setConcatenatedString(initialString + " " + stringToConcat); // Added spaces around the concatenation
  }, [initialString, stringToConcat]);

  return concatenatedString;
};

export default useConcatenatedString;
